<div class="container-contact">
    <div class="container-contact-title">
        <h2>{{ 'contactForm.title' | translate }}</h2>
    </div>
    <div class="container-contact-description">
        <p>{{ 'contactForm.description' | translate }}</p>
    </div>
    <div class="container-contact-content">
        <form [formGroup]="contactForm">
            <div class="form-group">
                <mat-form-field appearance="fill" style="width: 60%;">
                    <input matInput formControlName="subject" id="subject" [placeholder]="'contactForm.subject' | translate" />
                </mat-form-field>
            </div>
            <div class="form-group">
                <mat-form-field appearance="fill" style="width: 100%;" >
                    <textarea matInput formControlName="message" id="message" [placeholder]="'contactForm.message' | translate" ></textarea>
                </mat-form-field>
            </div>


            <div class="form-message" *ngIf="error_message || confirmation_message">
                <p [ngClass]="{'form-error-message': error_message, 'form-confirmation-message': confirmation_message}">{{error_message || confirmation_message}}</p>
                <img class="form-error-icon" src="/assets/boton-x.png" alt="Error" (click)="closeMessage()">
            </div>

            <div class="form-actions">
                <button mat-button (click)="send()" [disabled]="sending">
                    <span *ngIf="!sending">{{ 'contactForm.send' | translate }}</span>
                    <div style="height: 30px;" *ngIf="sending" class="loading-button-container">
                        <img class="loading-button" src="/assets/spinner.gif" alt="Cargando...">
                        <span>{{ 'contactForm.sending' | translate }}</span>
                    </div>
                </button>
            </div>
        </form>
    </div>
</div>

<button mat-icon-button class="close-modal-btn" style="position: absolute; top: 10px; right: 10px;" (click)="close()" [attr.aria-label]="'contactForm.close' | translate">
    <div class="close-modal-btn-container">
      <p class="close-modal-btn-text">&times;</p>
    </div>
</button>